import React from 'react';
import "../../assets/scss/components/form/list-input.scss"

const ListInput = ({children, ...props}) => {
    return (
        <div className="list-input">
            <div className="row align-items-center">
                <div className="col-xs-6">
                    <div className="list-input-title">
                        {props.title}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="list-input-content">
                        { children }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListInput;
